import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import HomepageTemplate from '../components/Homepage.js';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <PageDescription mdxType="PageDescription">
      <h2>{`A Rare Intersection of Skills`}</h2>
      <p>{`Coding? Writing? Data Science? I offer you the complete package. Do you need:`}</p>
    </PageDescription>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`A `}<strong parentName="p">{`data scientist`}</strong>{` who can also tell a `}<strong parentName="p">{`compelling story?`}</strong></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`A `}<strong parentName="p">{`technical writer`}</strong>{` who can also `}<strong parentName="p">{`code?`}</strong></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`A `}<strong parentName="p">{`coder`}</strong>{` who can also `}<strong parentName="p">{`communicate?`}</strong></p>
      </li>
    </ul>
    <p>{`I’d love to help.`}</p>
    <div className="blockquote-highlight">
      <blockquote>
        <p parentName="blockquote"><strong parentName="p">{`My ideal client:`}</strong>{` a `}<strong parentName="p">{`mission-driven organization`}</strong>{` working to solve a `}<strong parentName="p">{`global problem`}</strong>{` that `}<strong parentName="p">{`doesn’t get enough attention`}</strong>{`.`}</p>
      </blockquote>
    </div>
    <h2>{`Explore What I Can Do For You`}</h2>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Data Science</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Coding and Web Development</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Writing</AnchorLink>
  <AnchorLink mdxType="AnchorLink">People Skills</AnchorLink>
    </AnchorLinks>
    {/*
     <Row>
      <Column colMd={3} colLg={3}>
     <ArticleCard
      color="dark"
      title="Data Science"
      href="#data-science"
      actionIcon="">
     ![MicroMasters](https://picsum.photos/1200/600)
     </ArticleCard>
       </Column>
      <Column colMd={3} colLg={3}>
     <ArticleCard
      color="dark"
      title="Coding"
      href="#coding"
      actionIcon="">
     ![MicroMasters](https://picsum.photos/1200/600)
     </ArticleCard>
      </Column>
      <Column colMd={3} colLg={3}>
     <ArticleCard
      color="dark"
      title="Writing"
      href="#writing"
      actionIcon="">
     ![MicroMasters](https://picsum.photos/1200/600)
     </ArticleCard>
      </Column>
      <Column colMd={3} colLg={3}>
     <ArticleCard
      color="dark"
      title="People Skills"
      href="#people-skills"
      actionIcon="">
     ![MicroMasters](https://picsum.photos/1200/600)
     </ArticleCard>
      </Column>
     </Row>
     */}
    <h3>{`Data Science`}</h3>
    <div className="list-badges">
      <img {...{
        "src": "https://img.shields.io/badge/edX-%2302262B.svg?style=for-the-badge&logo=edX&logoColor=white",
        "alt": "edX"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/python-3670A0?style=for-the-badge&logo=python&logoColor=ffdd54",
        "alt": "Python"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/jupyter-%23FA0F00.svg?style=for-the-badge&logo=jupyter&logoColor=white",
        "alt": "Jupyter Notebook"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/r-%23276DC3.svg?style=for-the-badge&logo=r&logoColor=white",
        "alt": "R"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/pandas-%23150458.svg?style=for-the-badge&logo=pandas&logoColor=white",
        "alt": "Pandas"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/numpy-%23013243.svg?style=for-the-badge&logo=numpy&logoColor=white",
        "alt": "NumPy"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/Matplotlib-%23ffffff.svg?style=for-the-badge&logo=Matplotlib&logoColor=black",
        "alt": "Matplotlib"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/scikit--learn-%23F7931E.svg?style=for-the-badge&logo=scikit-learn&logoColor=white",
        "alt": "scikit-learn"
      }}></img>
    </div>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" subTitle="Overview" title="Data Science" href="/data-science/" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "495px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC2UlEQVQ4y6WTWYvcOBSF62/nJZBfk5dmyKQgIUy2hmz0Q3UldsuSrM1LeelyddmWZcv7YKs69DAwL/NxH4wkc47OvdrM/4PNNE1FUUgpi6LIsux4POZ5XpZlnudm/XQ65XleVVVRFGVZKqWklA8PD2maLj8zxna7nRCCMYYQ4pwTQoQQURQdj0cAgGVZjDFKKUIIrIRh6LruZhxHAMDd3V2apkIIQojjOLZtn8/neZ6nafov2/M8+57HGRNccMbCIIgOB4yQ73nQcQLPP4QhRkhw7gnhe94hCHzGmOsKQhblMI6Z58m67qep6fum71TbqratWl13reradhgOSUyFiJJEhCFMEi/P1Txv+kbfvnv/9dXW+nANr79kezvb32W39lJ723zwrzc/tm9utm9v33+G377zly8PV1f3r19vRt2ivz7t/nyz376F7z7mN/vmp6N/wd/VWsi//vbj6tXujy349CX4fH169qx68aJ4/nxJ+xBHYXRgnIdR5GBcKtVPox76S42D7rsgDCnncRL7cWxHkXs64Sxb7kwpBQBgjF3XtVcAAKa3ZVlWVZVlmekIpZRRCiyLYkwQWpTpClmJosgMQ13XzYrWWkoJVyilQgjbtjHGCKFFGa+4rus4zvl8bttWa900Tf2IlNIc4JwLITDGSZLEcbwou64LAIAQAgCOx2NRFGY2q6pSj1BKIYRCCCPe933btsuQrD2/YA5ZK3me/7bAOQcAeJ7HOaeUaq3rur7MtmVZxhJCCEKIMZZS1nVtZKWUxp3neUZZa11V1SUwYwkhxBgzISulmke01owxCKHv+0KIJEm6rmuaZgmMEGIyI4RwztM0zbLsaWBN0yRJ4jgOISQIgtPpdLE9jqNpAwDAcRzzHjnnSqnqEaXU+Xw2vYzjOM9zs7sZhsH3/SiKjHLf99M0DcPQPqHrurIsKaVxHN/f30spu667pG2Y/sm/X69ZfLr1N6KxQOKi7X40AAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "COVID-19 vs. Mass Casualties",
              "title": "COVID-19 vs. Mass Casualties",
              "src": "/static/7b7279f69e11f9f6be244b370e25f973/b3db0/covid-deaths-vs-mass-casualties-table-cropped.png",
              "srcSet": ["/static/7b7279f69e11f9f6be244b370e25f973/7fc1e/covid-deaths-vs-mass-casualties-table-cropped.png 288w", "/static/7b7279f69e11f9f6be244b370e25f973/b3db0/covid-deaths-vs-mass-casualties-table-cropped.png 495w"],
              "sizes": "(max-width: 495px) 100vw, 495px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Data Science" subTitle="UC San Diego" title="MicroMasters Certificate in Data Science" href="/data-science/#certification" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAADe0lEQVQ4y42UW28bRRiGn9mdmV0f1o7PdnzaJLbXu46TNE3TJEBiI6QmqDR1mhNFBKhoAYFAApVbrvgTSL3hkl/CL+DvBM3aLhGR2o720c5I3756v5l3losIqL2E8u9QeQlccxXBSQhn0W1OQ7gcwGHgQusZurGPbI6xG2NkYwwXEYL6c6j9APUryPzF5xHiJEScRbc5DRGXEeIocC1WviTVfp+kf4DTGqGbI5iEQpe6zXK50ywVO83KYreePwqVcxmhTkP0WfQfZm2YhLZ+0Uemm7tp3TooOc0PiqpxkFfNkeA4tLTT69x1e531VGe5k+n4rY9DpY3gk6mgOpuKv2YS2fppE9ke3Eu3Vvdq/vp+pRCMqyl/3zZ7ov8YYV+uoP6sY1//DY+66Md99ONgyvHsPenHDtVnQ9QnXVvmqy1mIwnoROM+mCLHZseVbDqS7UJSVK+vBV9toH7cRv6yg/x1D/nzDvLbu8hPV1H7Ldy2hwZt21I5CFFGiArCtmLBjEM749DyNH7OpdbIsNDOkl1aINPKkm3O1t08adP+uI1TTyEBG0gBCzOXYNopJinnE9RKSUp1j5xhe5HEqI3zXhP3fp3EvUUSZn4aoU8CVF4jbBFLZAETvma8Oo9Qac1KShGkFL1+kbQR26ySWCuTXK+Q3G3gfn0HdbWGOh+gHyyhZu4ciOfGrQdYXAxQRmBrceqiVyDtL5AJCqQ7ObxuHm9YJnk2PfU4Sg98ZM2zY0M1Z1nldFmXdSvlyXycfH05QM15sYn8aRtp3t9vIb/bQj7beJ1JNQnQRz6WEbOFVHm7mnCtdNYVXtXCsoiL+tNI3OTkf3MTl7ngXgVxON0xe9aynhHfT/025oE+j9APO6hxYRo+WwheLf1jpjmgBIh3EpyLGsGjZeRGx3xpnvhQErPIJOeCyly/SWjF9/TJDW6u40Ppow997Od3uDnEjSwKTPFvq8hvIuTToVBfrKHMIRjMFZtj6o576FEda70I2oqF9MylN2vZMr8qtRJUMxv9fPKj1jTIJkbbdRJjH+dDH2fk41yto66GqK0iYrcCvhe7s2YZtGZOgc4eohc9Er3Q7LWjtSykNUlPk8g6uI5NXtsUkgovo3F52+gHZeiu2XSHMtgbAK9YcInpF2/tVewiLd8guBzUoDuMWX24D5TJucRsVG/XZxSU3uDzXwCwi9vRh/TqAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "MicroMasters",
              "title": "MicroMasters",
              "src": "/static/13bf9d4cac86aea45240fe1d3e1748de/3cbba/bill-powell-micromasters-data-science-square.png",
              "srcSet": ["/static/13bf9d4cac86aea45240fe1d3e1748de/7fc1e/bill-powell-micromasters-data-science-square.png 288w", "/static/13bf9d4cac86aea45240fe1d3e1748de/a5df1/bill-powell-micromasters-data-science-square.png 576w", "/static/13bf9d4cac86aea45240fe1d3e1748de/3cbba/bill-powell-micromasters-data-science-square.png 1152w", "/static/13bf9d4cac86aea45240fe1d3e1748de/aee90/bill-powell-micromasters-data-science-square.png 1534w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" subTitle="Featured Project" title='Do Countries Have "Synthetic" Traits?' href="https://data.billalive.com/22719-country-synthetic-traits/" date="Python, pandas, scikit-learn" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1003px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACn0lEQVQ4y4VUy0ocQRSdL3HlQgRBFEUFXehKwY2CuBBciO78Aj8iG90kRHAnCAlxkdEPcJFIFkkIRMSFznT1o7rr1dXV3dX1CN01mTE4ksPty6WqDudUVd9qcc4JIYwxjDEZAKec2/+hFccJ8P16eQNGGaX1xxkr89xFkdcQQuQ9FEJkQogWYyxJEkIIpZQQCjzf80DsR8T3YwCSJqIw6Dx1AfC7XrfreY+PTxGMOOet5zaMMWEYQgiTJImTJIyiBCEYx1VWFbSQQpa8tLmRqTTK1LbNX5RlyTmXUpbPUMmKZvTq7qr9u319d3356/Lix8X59/ObhxtZylZfEwBACHF1f9Ba26Gd6bfT4yfjI29GVs5WDj8f7nzYOf12airTUkqVZSmlDMOQUvqS7DFv4f3C8tny7sfd9n3bWquNVkrled4SQgRBkCSJ53lpmr4k+wzMvJvZ+7RXj1ijjNJGV6oqiqJnW2vd7XaHK2fh2MnY/uW+03RTPWV3WgihIcpK2fsH+PPL5vnm8dfj51M9srW2KAoIYRAEA2W3CGM7O2vX1qyUzkn/UgdkZxsAMFDWjb3bWzsxYdfXbVkOJ+sGCKEBmRAbhpZze3RkR0ftxsar5DzP4ziOosj3fc65xdhsb9uxMTs1ZScn62J19VWytZZSGoWhHwQUIXtwoOfm9NKSWVzUS0t6fl5vbek8N83WjDEuV1U12LM7RkopDgLs+wzCBIBejuMsyxBCjDGXMcYIoboxlFJVVUkplVL1j11V/TBmYNQJuoF+O9QtCSEMGwRBHZ7nBcBPICyFkEWDvCj+LaoGLQhhp0GaplkmMi44z0ouVJaVjBVpylhKMWWMuYZ3hWuH+rTTNI2iyL0HmGBKKcKYNJkyRgjRWg99hv4AOP1JNlTehbEAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Chart",
              "title": "Chart",
              "src": "/static/ab74c8c32b0ea6f20c97a0de842e8638/a9c44/countries-synthetic-traits-chart1.png",
              "srcSet": ["/static/ab74c8c32b0ea6f20c97a0de842e8638/7fc1e/countries-synthetic-traits-chart1.png 288w", "/static/ab74c8c32b0ea6f20c97a0de842e8638/a5df1/countries-synthetic-traits-chart1.png 576w", "/static/ab74c8c32b0ea6f20c97a0de842e8638/a9c44/countries-synthetic-traits-chart1.png 1003w"],
              "sizes": "(max-width: 1003px) 100vw, 1003px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
    </Row>
    <h3>{`Coding and Web Development`}</h3>
    <div className="list-badges">
      <img {...{
        "src": "https://img.shields.io/badge/git-%23F05033?style=for-the-badge&logo=git&logoColor=white",
        "alt": "Git"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/python-3670A0?style=for-the-badge&logo=python&logoColor=FFDD54",
        "alt": "Python"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/perl-%2339457E?style=for-the-badge&logo=perl",
        "alt": "Perl"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/shell_script-%23121011?style=for-the-badge&logo=gnu-bash",
        "alt": "Shell Script"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/r-%23276DC3?style=for-the-badge&logo=r&logoColor=white",
        "alt": "R"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/php-%23777BB4?style=for-the-badge&logo=php&logoColor=white",
        "alt": "PHP"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/javascript-%23323330?style=for-the-badge&logo=javascript&logoColor=%22F7DF1E%22",
        "alt": "JavaScript"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/docker-%230db7ed?style=for-the-badge&logo=docker&logoColor=white",
        "alt": "Docker"
      }}></img>
      <br />
      <img {...{
        "src": "https://img.shields.io/badge/WordPress-%23117AC9?style=for-the-badge&logo=WordPress",
        "alt": "WordPress"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/Hugo-black?style=for-the-badge&logo=Hugo",
        "alt": "Hugo"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/Gatsby-%23663399?style=for-the-badge&logo=gatsby",
        "alt": "Gatsby"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/SASS-hotpink?style=for-the-badge&logo=SASS&logoColor=white",
        "alt": "SASS"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/jquery-%230769AD?style=for-the-badge&logo=jquery",
        "alt": "jQuery"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/NPM-%23000000?style=for-the-badge&logo=npm",
        "alt": "NPM"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/node.js-6DA55F?style=for-the-badge&logo=node.js&logoColor=white",
        "alt": "NodeJS"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/react-%2320232a?style=for-the-badge&logo=react&logoColor=%2361DAFB",
        "alt": "React"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/css3-%231572B6?style=for-the-badge&logo=css3",
        "alt": "CSS3"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/html5-%23E34F26?style=for-the-badge&logo=html5&logoColor=white",
        "alt": "HTML5"
      }}></img>
    </div>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Code" href="/code/" date="Python, R, PHP, Perl, JS, Git..." actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "700px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAFa0lEQVQ4y02Uf1DTBR/HvyWIMNjYl41t/NxgG2yMjY1tbAyQX/FLfheMSJGJQGGmiYnZD1PsSki9Usqzyx7tqetEsUcF8yGznrvnfE59LBKFyjtP8M4uscvKOs+6V9e8ut7/fd53n9e9P5/P3UfItjvRJSWToFKjUSqJWBCOKiqEVlc4izxa2jsfo2/DRjoDj1JfUEZdfjNFzk7UYjIquRS1KKKUSVGIIqJcRMi2uzDqDWiUsTgyrazt7eWl/hfobbZT7VSxNLCcVeueptJZQE1uKT1PrqN1STv5BYVIPMXM81USUdeGpvwh3G7vH0AnFrOFsHnz6Onq5svpaf7Q+U+Ps9Ak0uBv5dEneslxuDDIY3lr7z+YvTLLf0+fZcfIKIWBbiR2L8pMO2k2B4LFnBkEvj60i4uTk0xPT/Prb79y+cIUp05+wvq1PeRlG0k3mTh4aJgbN+Z48d1hho+Nce70aaYmvuDp1b1EekuRV/kRUlNSebCxKZjq9u3bTE9NBcEnThwPeu9tW0WZaQEti5cG6/bNA2T19fPLT79wYPgQt3/+mS0DryBP1BFrzkTQaXXUVNdz584dzp09x/Xr17l79y5/atezS6jNklBeVcm/x0/y2dVrvHVkjB9v3WLuxhxjn13A0rkaX0UdCQvLEVJ0Kfi8edTW1HD48OEg5OLFSUYODhNY/Aj5JgWuFCkZ5nScbjeLW/ycGB3lytWrvL1vP5NfX0GTYkAuylHFKhAS4xPI9fiYHxpKS4ufn279wLXLV3ihfwtSrRaFuwAxrwxlsg6FNJrQkBAMei11VeUY1FJWLamnJDudxIRkpLIYBLVKhdfjQ69PRalS4LVk0Vzfid7lw1iUiaYsg+RFBjKKFeQ1KqiuMVNvV2MyxNJcqqPSo6avIZHHlhVS9oARQRmjwOPJxaDXkxAfF4yuLyqnf+sgIyN7OXpyP3v2bKKto4G6QAWBnmVUtrRSuvElrGueI72jl2XdbfR0l7G8owpBlEXjzvFiNplRKkTsWTY+P/9/jn7wL/YNDvH+7v0cfneYyfNn6Vi9FklVE56VT7Hv+Dgfn/oPVfV+ymtbcLjzMWXYEGSSSJxOFzabDVEuw+fLZXJigj07X+PzT//H8D/f542du/j+u5s0+huIVsvpamvi1IfH+PHba7QVpVGkCyXHZkYuj0aICo8gK8uBw+EkLl6DWhlDTsUi3vzwJFNfTXDhi9Mc++gg3WsbcFZLWVidSVNFBl1PrqBrwxoaHvZQ7C8hpaUdW20zgiQsPDhudrYLhSIGuSwSRVo6YSlGsu0ZFNuzMCVF4LWF4Cy0kOxvJLGtnaTah4iraULXsQbr0pXoy+tIMFsQIkLDSDMaybBYCQTa2br1ZWSScNQqkVxtJoXJdkpcHupzi8nVRVPuSMLtKOC5jf2cPXOGo4cO8cn4ON3LAoSHhdwDxmk0DA29wfhH4xw5eoSBgQGUKiVqmUhJXj7v7H6Ttwd30b3IzxL/CrIyatnx6uv8XYOvDCLcJyCECPdhs2YGzZs359jwzAZmZmYoKS3BkBrP5MQZrs/OMDszyzc359g+tBOTzcL2HduDPcdGRzkwfIDN/ZuJkEQgLJg3n2ipjP4tL3Lp0iUmJibYtGkjUrkUW0oql89f+CvF0O6dFFRXkpCezvPbtgW9kbExDux9h1e3vYY7vxAh7P6Q4Lc1W6ys6+tj/fo+JJLwexdXKEhPNdLxyIMsr/Ri0Gqw57gxOFz4ahpZsXI17Z1drHp8BRUPlKCNi7kHlEVG4vHmkqzVEhUlIT5egyZOjSZeE9ylKI9CEyuiTYwjSa/EYI3BaJOgzwmnIEdNo3U+1rR4Wn1x/A6pJk9pnTuqTwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Code",
              "title": "Code",
              "src": "/static/a253713f7c0925e03170ce0dae97a844/f847a/code.png",
              "srcSet": ["/static/a253713f7c0925e03170ce0dae97a844/7fc1e/code.png 288w", "/static/a253713f7c0925e03170ce0dae97a844/a5df1/code.png 576w", "/static/a253713f7c0925e03170ce0dae97a844/f847a/code.png 700w"],
              "sizes": "(max-width: 700px) 100vw, 700px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Web Development" href="/web-dev/" date="WordPress, Hugo, Gatsby" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "700px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAFhElEQVQ4yx3M/VPT9wHA8U8CIYFvSHgKkBAIISEJQjHlITxXRZCYgFghCAKzIAgB6agPY+pExAqclBaptFIo04onghV3Vau1WjdvJ2hrbU90c9e63brr7rbudvuhO28P7133+gNeIrF8iND4UqTYAtT6QkxF3cgjc4kt2IU+dzdRqXsx135Edsd9Ops/I3PF60Sqn0MIQYIw0CTlkhxgwCrTM6x3IYyeQbRmDxp9ITLN8yTmt2PLriExv41gZzfha05g2nKLUNc4vorbVJpPYtNtIifvBdyWYraLPOJFFIVKC6esqxD6sn7CrRsIDMtmbUU7HftOsLn1MC3dR9nwk4tI3gvErFsg1NGLLWWCAyVzTA6co79vgpmj7/Hzl4fJCDZTF2SnJyEDYSg9SFCcG1/DHjp2DmHOqsfi2orasokLv/wd47OPUaS8SbB9gC2d51mc+zNDe0+jVq2mOr2Wa8dOM3dsil7nemolEyLC1UZESg13lh4wd/EGloxqvn76R9yNg4ycXuS7vz/DsWYMpe0IU7MP6HRe508P/kaqdTPH9k9y7vDrtOZ4OX9gmHyhQajTtrByrZ/9h99i+fFXyMJdLFy6ycCbH5CyYZRzt76lyDdNgGU/xyeX8Nnm+cuTf3Lj4yX++vvvmD40TO2KFxjefQitCESEpjeRta4dj6+Lyzfu0trVz88GJrn/4AmrakboGH3I2hdHCTB08PbUZ2y0vM83T/7Bkaa3+PLsEuNH3yA3MZNDew4S90MYkdGCIbORrZ0D9Bx5l7v3Pifbs5Pb979mfOo2Lb03sRb2IaIaOXXmUzqcV/nyyre0JexmsnOS4T29tHjrGdy5H6sIQUQ5a5GSN5Je0Mjg6CkeLT9Cba5gemGJxcWn5NVME+j4KQFSGTXeEa6eXub6gT/gjx7E7/Lz/rFpxgZGyYhOJiVIgwhzeIlMq0QyubEVvERVfTcNL4/Q0neFrOJBQmLbiU7bR4i+kmTtLnqSjnN17x0+OvEFH45dYq+7BZ0IJ0GmxREiIbS2MrT29eidDaitGxAiCclahz73NaR4P3JdPULXjJDW4Va1sFM6wA5xkKMrz7Mjfh+rhYUYhQGTQodVFYLQWteiTV6HwdVGZPoWhMaJNs2PedVryE1NrMhvp+fVGcZfPclEzTBtQQ3sUPl5JWyC7dazlGry0AfoSVTEYFepERrLGrTWUuLyu4hwVCFT2ghL70Seto+K1nEuXf6EmYkFbp68x+25RS70zVMXuI2G8F66TAsUxzQTK48lURGHIzgUEZpYiMbmJnlFI/roPCQRjUm1EruulPkzH/LOxCzff/+MH3z1+VOePfs3fd43qBbN7IqeYL3xENGhOZgDjdhVGoROiibS8DzPJddg1GahCMsiSOche1Un9+4uMzM2A//51//Dx3ce8s1vnnK2fxavqKJbexhfeA+6iEpMUhY2pYSIlQUQr9CQYqlHF70GWVQhwlCJMaeFX916xNgrb3NxZBb+C0uXfs17B99hcs8UxcJDu3obdRFdxGkqMEaUYZESENooOzGxmZhye9DYfMjC81AkvIgIK2H4+EV+MXCekzummB+5zJUzt1i89imbzW2UB2xma0gTdWF+rJoqjNpSLJp0REhcNhGplSR4h9Cm+pAbSgi0VCMSNmJwtDI/ep2H179geem3fPDuNfx5PyZfFOMJrsKnbKBDtY2VUjlx6iKS1A6EOi4LfVYDZm8/oY5KAk1u5PFuZPHrUcXXkhflp9nYhNdST4FUQZEowxPswaUsITu4gh+pXqJIWYxRlY492IbQmnLQ57dirBhCaSpDFrMaeVI18iQfAamd6CytZAaWk6yoIkW9FWd4Fy6pDqfKg10qpyR0O56QTViVSTiVev4H+6YjfAd34CsAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Web Development",
              "title": "Web Development",
              "src": "/static/38fa523e70f2ad4c1c8f4d3eedbe6251/f847a/web-development.png",
              "srcSet": ["/static/38fa523e70f2ad4c1c8f4d3eedbe6251/7fc1e/web-development.png 288w", "/static/38fa523e70f2ad4c1c8f4d3eedbe6251/a5df1/web-development.png 576w", "/static/38fa523e70f2ad4c1c8f4d3eedbe6251/f847a/web-development.png 700w"],
              "sizes": "(max-width: 700px) 100vw, 700px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" subTitle="Featured Project" title="Yarm: Yet Another Report Maker" date="Python" href="/code/#yarm:-yet-another-report-maker" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "438px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLElEQVQ4y2OQkJElGzGMUM3SciCWlKyslKyclKystJwcBGGypWTlQOrBykCaxaRlucWkxGVkBSVk+MSkBSVlOISlOEWkuESkBCVluMWkOEWlOESk+CVAbEEpaQkZWW5xKQFJaUkZWQYVRfkMex0JaVkva/VwJy1LXaWWCKPGcKO6MEMnA5UcR90mb4NWX8NoS810Oz1TDWURKZl4Cy1/Qw1BSRkGfRWF/3X2AcaqjcF6D9ptpsQYPGi1vd1k+2Oy04IYo0+Vtq+q7S4XW6c7aL0tc3xcYLsj0uh/leMUHwNOMWkGTWX5qcF6rYHaV2rNLzSae1ioLM8z3Fdt8nyC9ZI0w3u1Fjb6irwSUnrq8vcqzO9VWjyusXpabTExRJdLVJpBSlaWWUhKUVHuZJP5tX6rnS1mLxfaba42eb/Mblmx8ePJNobailzC0lYGSh9n2WZ6a2qqyp/vsJyfZcguJMUgJCkTZad2tcXy3zL7rkS9phS979sdn66x+7zFYVmN8bPFdib6igJiMirK8rfm2CT4aDKwSSwtN55TZMQhKMUgKi1rb6AcZKXqYqIsKSMrLi3rYaMS4KTqaatqaajkYaUipyAnLiMrIiljrKeorakgLCmjoCBnpKMoKiXLICkjKyAhwyMqzScmA4l6PjFpXlEQgkSeuDRIUFJWVkhCRkRSRlJWVkxaVkhSRhKSSEAJAIwgmqXloAicMBDpSUoWZATIIBkog2E0S5KmGQDr9smRR81poQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Yarm",
              "title": "Yarm",
              "src": "/static/52c45321fcfd3c242cf8ac649fbb76ef/33837/yarm_dark_square.png",
              "srcSet": ["/static/52c45321fcfd3c242cf8ac649fbb76ef/7fc1e/yarm_dark_square.png 288w", "/static/52c45321fcfd3c242cf8ac649fbb76ef/33837/yarm_dark_square.png 438w"],
              "sizes": "(max-width: 438px) 100vw, 438px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
    </Row>
    <blockquote>
      <p parentName="blockquote">{`“Heartfelt thanks to Bill Powell… who developed this website and with infinite patience and contagious enthusiasm taught `}{`[us]`}{` to maintain it ourselves.”`}</p>
      <cite>Traverse City, Michigan</cite>
    </blockquote>
    <h3>{`Writing`}</h3>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Nonfiction Writing" href="/nonfiction/" date="Tech, Memory, For Writers" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "160.06944444444443%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "nonfiction",
              "title": "nonfiction",
              "src": "/static/1ad7a010b23117bd884a7178f7ac358c/3cbba/nonfiction.png",
              "srcSet": ["/static/1ad7a010b23117bd884a7178f7ac358c/7fc1e/nonfiction.png 288w", "/static/1ad7a010b23117bd884a7178f7ac358c/a5df1/nonfiction.png 576w", "/static/1ad7a010b23117bd884a7178f7ac358c/3cbba/nonfiction.png 1152w", "/static/1ad7a010b23117bd884a7178f7ac358c/362ee/nonfiction.png 1600w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Fiction Writing" date="Mystery, Humor, SF, Kids" href="/fiction/" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "160.06944444444443%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBAgQF/8QAFwEAAwEAAAAAAAAAAAAAAAAAAgMEAP/aAAwDAQACEAMQAAABQ6rBs5xrMzPC4OOxAL//xAAcEAACAgIDAAAAAAAAAAAAAAABAgMRABITISL/2gAIAQEAAQUCiRCNI8KgmPpr2LQspaRgFkOgdgKvOPyFNf/EABgRAAMBAQAAAAAAAAAAAAAAAAABEQIS/9oACAEDAQE/AdYVOcFdFT//xAAXEQADAQAAAAAAAAAAAAAAAAAAECER/9oACAECAQE/AdUIf//EABwQAAEEAwEAAAAAAAAAAAAAAAABEBEhAhIxMv/aAAgBAQAGPwKFfkmkdbG+FqVkpEoekb//xAAcEAEBAQEAAwEBAAAAAAAAAAABEQAhMUFhUXH/2gAIAQEAAT8hQF313J+T691YlxqYtw7waAg/R01oV8+deHnU726eAf3euAdrj8Mllzq3/9oADAMBAAIAAwAAABDD03D/xAAZEQEAAwEBAAAAAAAAAAAAAAABABEhMYH/2gAIAQMBAT8Q1DnkFLKiXcVMJ//EABcRAAMBAAAAAAAAAAAAAAAAAAABEVH/2gAIAQIBAT8QSlJkbwf/xAAfEAEBAAICAwADAAAAAAAAAAABEQAhMVFBYXGBkbH/2gAIAQEAAT8QU29aANePrioqAGxxq/3HnolvGUiyBPBu764xIVaTo/P6yk0lKhyhdM1LjH1rL1t1XBAv3N4Qs7YnUj4Y7kO5cRDchyfJ3huEu9jn/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Murder Feels Awful",
              "title": "Murder Feels Awful",
              "src": "/static/0dba9dbff0d68c777f40d3a2cc890cf8/2e753/mfa.jpg",
              "srcSet": ["/static/0dba9dbff0d68c777f40d3a2cc890cf8/69549/mfa.jpg 288w", "/static/0dba9dbff0d68c777f40d3a2cc890cf8/473e3/mfa.jpg 576w", "/static/0dba9dbff0d68c777f40d3a2cc890cf8/2e753/mfa.jpg 1152w", "/static/0dba9dbff0d68c777f40d3a2cc890cf8/490e5/mfa.jpg 1600w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Games" date="Perl, Javascript, Twine, Inform" href="/games/" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "160.06944444444443%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Games",
              "title": "Games",
              "src": "/static/67af0920b35beacf484289ee6719a9bb/3cbba/games.png",
              "srcSet": ["/static/67af0920b35beacf484289ee6719a9bb/7fc1e/games.png 288w", "/static/67af0920b35beacf484289ee6719a9bb/a5df1/games.png 576w", "/static/67af0920b35beacf484289ee6719a9bb/3cbba/games.png 1152w", "/static/67af0920b35beacf484289ee6719a9bb/362ee/games.png 1600w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <blockquote>
      <p parentName="blockquote">{`“You are competent and honest and communicate very well`}<br parentName="p"></br>{`
`}{`(a rare quality in a techie 🙂).”`}</p>
      <cite>Gower, Missouri</cite>
    </blockquote>
    <p>{`Note: My real name is `}<strong parentName="p">{`Bill Powell`}</strong>{`, but my (favorite) pen name is `}<strong parentName="p">{`Bill Alive`}</strong>{`.`}</p>
    <h3>{`People Skills`}</h3>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Customer Care" href="/customer-care/" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "https://picsum.photos/id/870/600/600",
            "alt": "Customer Care"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Art Director" href="/art-director/" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "https://picsum.photos/id/1059/600/600",
            "alt": "Art Director"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="Community" href="/community/" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "https://picsum.photos/id/441/600/600",
            "alt": "Community"
          }}></img>
        </ArticleCard>
      </Column>
    </Row>
    <blockquote>
      <p parentName="blockquote">{`“We have never found anyone who has understood what we wanted…
something simple but beautiful… You don’t realize how rare you are!”`}</p>
      <cite>Kansas City, Missouri</cite>
    </blockquote>
    <p>{`Want the full tour? Start with “Data Science” below…`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      